/**
 * Constants
 **/
export const FETCH_START = "fetch/FETCH_START";
export const FETCH_RESPONSE = "fetch/FETCH_RESPONSE";
export const FETCH_ERROR = "fetch/FETCH_ERROR";

/**
 * Action Creators
 **/
export const fetchStart = name => ({
  type: FETCH_START,
  name,
});

export const fetchResponse = response => ({
  type: FETCH_RESPONSE,
  response,
});

export const fetchError = error => ({
  type: FETCH_ERROR,
  error,
});



// WEBPACK FOOTER //
// ./src/redux/ducks/fetch.js